import { useSelector } from 'react-redux';
import {
    FormControl,
    FormErrorMessage,
    FormHelperText,
    useColorModeValue,
} from '@chakra-ui/react';
import { FormLabel, Input } from 'components/v4';

import walkthroughIds from './walkthroughIds';

// Copy field for single textfield components when copying modals
const ModalCopy = ({ setModalState, modalState, modalStateError }) => {
    const handleModalCopy = (e) => {
        setModalState({ copyName: e.target.value });
    };
    const { darkMode } = useSelector((state) => state.settings);

    return (
        <FormControl>
            <FormLabel style={{ color: darkMode ? 'white' : 'black' }}>Copy as</FormLabel>
            <Input
                value={modalState?.copyName}
                onChange={handleModalCopy}
                data-walkthroughid={walkthroughIds.modal.ufCopyInput}
                style={{
                    background: darkMode ? '#23272F' : 'white',
                    color: darkMode ? 'white' : 'black',
                    borderColor: darkMode ? '#444950' : '#ccc',
                }}
            />
            {modalStateError?.copyName ? (
                <FormErrorMessage style={{ color: darkMode ? '#ff6b6b' : undefined }}>
                    {modalStateError?.copyName}
                </FormErrorMessage>
            ) : (
                <FormHelperText style={{ color: darkMode ? 'white' : 'black' }}>
                    {modalStateError?.copyName}
                </FormHelperText>
            )}
        </FormControl>
    );
};

export default ModalCopy;